import Rete from 'rete';

import EffectChain from './EffectChain';
import { EFFECTCHAIN_INPUT_SOCKET, EFFECTCHAIN_OUTPUT_SOCKET } from '../SOCKETS';

class EffectChainComponent extends Rete.Component {
  constructor() {
    super('EffectChain');
    this.render = 'vue';
    this.data.component = EffectChain;
    this.data.props = {};
  }

  builder = node => {
    const input = new Rete.Input('inputs', '', EFFECTCHAIN_INPUT_SOCKET, true);
    const output = new Rete.Output('outputs', 'Then', EFFECTCHAIN_OUTPUT_SOCKET);

    node.addInput(input);
    node.addOutput(output);
  };
}

export default EffectChainComponent;
